.root {
  min-inline-size: 0;
}

.root[data-direction="forward"] {
  animation-name: slide-in-forward;
  animation-duration: var(--motion-duration-medium2);
  animation-timing-function: var(--motion-easing-emphasized-decelerate);
}

.root[data-direction="back"] {
  animation-name: slide-in-back;
  animation-duration: var(--motion-duration-medium2);
  animation-timing-function: var(--motion-easing-emphasized-decelerate);
}

@keyframes slide-in-forward {
  from {
    opacity: 0;
    transform: translateX(var(--space-8));
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes slide-in-back {
  from {
    opacity: 0;
    transform: translateX(calc(var(--space-8) * -1));
  }

  to {
    opacity: 1;
    transform: none;
  }
}
